var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{ 'text-success': _vm.paid_out, 'text-warning': !_vm.paid_out },staticStyle:{"font-size":"1.5em"}},[_c('i',{staticClass:"fa fa-table"})])}
var staticRenderFns = []

export { render, staticRenderFns }